import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { isBrandInNAM } from "../../../utils/isBrandInNAM";
export var usePaymentUpdatePayoutsArticles = function usePaymentUpdatePayoutsArticles() {
  var articles = useArticles();
  if (isBrandInNAM(getBrand())) {
    return [articles.InvoicesAndBilling.NAM_SELL_ON_FAIRE];
  } else {
    return [articles.InvoicesAndBilling.NON_NAM_SELL_ON_FAIRE];
  }
};